import { useEffect, useState } from 'react';

const NARROW_VIEWPORT_BREAKPOINT = 1280;

export function useIsNarrowViewport(): boolean {
  const [isNarrow, setIsNarrow] = useState(false);

  useEffect(() => {
    const checkWindowSize = () => {
      setIsNarrow(window.innerWidth < NARROW_VIEWPORT_BREAKPOINT);
    };
    checkWindowSize();
    window.addEventListener('resize', checkWindowSize);

    return () => {
      window.removeEventListener('resize', checkWindowSize);
    };
  }, []);

  return isNarrow;
}
